(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-modal"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    const stateOfModal = $('#announcement-Modal').data('disable-modal');

    if (stateOfModal == 'hide' || stateOfModal == '') {
      $('#announcement-Modal').modal('hide');
      localStorage.removeItem('announcement-modal')
    } else {
      const countOfModal = $('#announcement-Modal').data('show-count');

      const announcement_modal = localStorage.getItem('announcement-modal') || 'true';

      if (announcement_modal === 'true') {
          $('#announcement-Modal').modal('show');
          localStorage.setItem('announcement-modal', 'false');
        } else {
          $('#announcement-Modal').modal('hide');
        }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  let listItems = document.querySelectorAll('.footer-accordion .accordion-item');

  for (var i = 0; i < listItems.length; i++) {
    listItems[i].addEventListener('click', function () {
      // Remove the active class from all list items
      for (var j = 0; j < listItems.length; j++) {
        listItems[j].classList.remove('active');
      }

      // Add the active class to the clicked list item
      this.classList.add('active');
    });
  }

  // <!-- Initialize Swiper -->
  $(document).ready(function () {
    // Showing Submit button when we type something on email tag
    $('#contactFormEmail-2').on('keyup', function (event) {
      const email = event.target.value;
      const errorElement = $('.rm-error-js');
      const submitButton = $('.rm-fc-submit-2-js');

      // Regular expression for basic email validation
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (email === '') {
        errorElement.removeClass('d-none').text('Email can’t be blank');
        submitButton.removeClass('rm-form-control-submit');
        submitButton.addClass('d-none');
      } else if (!emailPattern.test(email)) {
        errorElement.removeClass('d-none').text('Please enter a valid email address');
        submitButton.removeClass('rm-form-control-submit');
        submitButton.addClass('d-none');
      } else {
        errorElement.addClass('d-none').text('');
        submitButton.addClass('rm-form-control-submit');
        submitButton.removeClass('d-none');
      }
    });

    // Clear Input Field
    $('.rm-form-reset-js').on('click', function () {
      $('#contactFormEmail-2').val('');
      $('.rm-error-js').addClass('d-none').text('');
      $('.rm-fc-submit-2-js').removeClass('rm-form-control-submit');
      $('.rm-fc-submit-2-js').addClass('d-none');
    });

    // Close Stay updated container
    $('.close-btn-stay-updated-js').on('click', function () {
      // $('.stay-updated-container-js').addClass('d-none');
      $('#contactFormEmail-2').val('');
      $('.rm-fc-submit-2-js').removeClass('rm-form-control-submit');
      $('.rm-fc-submit-2-js').addClass('d-none');
      $('.rm-error-js').removeClass('d-none').text('Email can’t be blank');
    });

    $('.sfa-link-js').click(function () {
      const currency = $(this).data('display-text');
      $('#hidden-currency-js').val(currency);
      $('.currency-text-desplay-js').text(currency);
    });

    // $('.accordion-item-js').on('click', function (e) {
    //   // e.preventDefault();
    //   if($(window).width() >= 768){
    //     $('html, body').animate(
    //       {
    //         scrollTop: $(this).offset().top + $(this).outerHeight(),
    //       },
    //       2500
    //     );
    //   }
    // });

    // $('.accordion-item-js').on('shown.bs.collapse', function () {
    //   var panel = $(this).find('.show');
    //   console.log('Footer');
    //   $('html, body').animate(
    //     {
    //       scrollTop: panel.offset().top,
    //     },
    //     800
    //   );
    // });
  });

  document.getElementById('newsletter-footer-form').addEventListener('submit', function (e) {
    e.preventDefault();
    // console.log('form active');

    let formMessageDisplay = {
      signup_msg: 'Thank you! You are now Signed Up.',
      subscribe_msg: 'Thank you! You are already subscribed.',
      error_msg: 'Sorry, there was an error. Please try again.',
    };

    let email = document.getElementById('contactFormEmail-2').value;
    let formMessage = document.querySelector('.form-message-display-js');
    let formMessageContainer = document.querySelector('.rm-form-success-js');
    let formLoaderCont = document.querySelector('.form-submit-container-js');
    let formContainer = document.querySelector('#newsletter-footer-form');
    // console.log('Email:', email);

    // Show the loader
    formLoaderCont.classList.add('form__loader--active');

    // Shopify specific AJAX call
    let xhr = new XMLHttpRequest();
    let url = '/contact';
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        console.log('inside xhr');

        // Hide the loader when the request is complete
        formLoaderCont.classList.remove('form__loader--active');

        // form will hide and message will display
        formContainer.classList.add('d-none');

        if (xhr.status === 200) {
          localStorage.setItem('isNewsLetterSubscribe', 'true');
          formMessage.innerHTML = formMessageDisplay['signup_msg'];
          formMessageContainer.classList.remove('d-none');
        } else {
          formMessage.style.color = 'red';
          formMessage.innerHTML = formMessageDisplay['error_msg'];
          formMessageContainer.classList.remove('d-none');
        }
      }
    };

    xhr.send('form_type=customer&contact[email]=' + encodeURIComponent(email));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 991px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      //this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  const list_menu__item = document.querySelectorAll('.list-menu__item');
  const rm_logo = document.querySelector('#HeaderMenu-रॉ-मैंगो span');
  const mySearch = document.querySelector('.my-search');
  const cartIconBubble = document.querySelector('.header__icons a#cart-icon-bubble');
  const listMenuItems = document.querySelectorAll('.list-menu--inline .list-menu__item');
  const accordionMenu = document.querySelectorAll('.top-menu-dropdown #accordionMenu');
  // const shopMenuId = document.querySelector('#shop-menu');
  const craftMenu = document.querySelector('.shop-menu-js[data-shop-menu="craft"]');
  const shopMenu = document.querySelector('.shop-menu-js[data-shop-menu="shop"]');
  const shopMenuAll = document.querySelectorAll('.shop-menu-js');
  const mainBody = document.querySelector('body');


  let headerId = '';

  function HeaderActiveShop(){
      if(rm_logo){
        rm_logo.classList.add('white-logo');
      }

      if (mySearch) {
        mySearch.style.color = `#fff`;
      }

      if (cartIconBubble) {
        cartIconBubble.style.color = '#fff';
      }

      listMenuItems.forEach(item => {
        item.style.color = '#fff'; 
      });
  }

  function HeaderDeActiveShop(){
      if(rm_logo){
        rm_logo.classList.remove('white-logo');
      }

      if (mySearch) {
        mySearch.style.color = `#084d2d`;
      }

      if (cartIconBubble) {
        cartIconBubble.style.color = '#084d2d';
      }

      listMenuItems.forEach(item => {
        item.style.color = '#084d2d'; 
      });
  }

  function HeaderInterval_Start(){
    headerId = setInterval(() => {
      if (!shopMenu.classList.contains('show') && !craftMenu.classList.contains('show')) {
        HeaderDeActiveShop();
        HeaderInterval_Stop();  
      }
    }, 100);
  }


  function HeaderInterval_Stop(){
      clearInterval(headerId);
  }

  shopMenuAll.forEach(menu => {
    menu.addEventListener('click', function() {
      if (menu.classList.contains('show')) {
        HeaderActiveShop();
        HeaderInterval_Start();
      }else{
        HeaderDeActiveShop();
        HeaderInterval_Stop();  
      }
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // setTimeout(() => {
    //   settingHeight();
    // }, 6000);
    // settingHeight();
    // function settingHeight() {
    //   let modalBodyHeight = $('.modal-body').height();
    //   let modalContentHeight = $('.modal-content').height();
    //   const newsLetterHeaderHeight = $('.rm-newsletter-upper').height();
    //   const newLetterLowerHeight = modalBodyHeight;
    //   if ($(window).width() <= 1440) {
    //     $('#newsletter-modal .modal-content').css('height', `auto`);
    //   } else {
    //     $('#newsletter-modal .modal-content').css('height', `auto`);
    //   }
    // }
    // $(window).on('resize', settingHeight);
  });

  document.getElementById('newsletter-popup-form').addEventListener('submit', function (e) {
    e.preventDefault();
    // console.log('form active');

    let formMessageDisplay = {
      signup_msg: 'Thank you for signing up!',
      subscribe_msg: 'Thank you! You are already subscribed.',
      error_msg: 'Sorry, there was an error. Please try again.',
    };

    let email = document.getElementById('contactFormEmail').value;
    let formMessage = document.querySelector('.form-message-display-popup-js');
    let formMessageContainer = document.querySelector('.rm-form-success-popup-js');
    let formLoaderCont = document.querySelector('.form-submit-container-popup-js');
    let formContainer = document.querySelector('#newsletter-popup-form');
    // console.log('Email:', email);

    // Show the loader
    formLoaderCont.classList.add('form__loader--active');

    // Shopify specific AJAX call
    let xhr = new XMLHttpRequest();
    let url = '/contact';
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        console.log('inside xhr');

        // Hide the loader when the request is complete
        formLoaderCont.classList.remove('form__loader--active');

        // form will hide and message will display
        formContainer.classList.add('d-none');

        if (xhr.status === 200) {
          localStorage.setItem('isNewsLetterSubscribe', 'true');
          formMessage.innerHTML = formMessageDisplay['signup_msg'];
          formMessageContainer.classList.remove('d-none');
        } else {
          formMessage.style.color = 'red';
          formMessage.innerHTML = formMessageDisplay['error_msg'];
          formMessageContainer.classList.remove('d-none');
        }
      }
    };

    xhr.send('form_type=customer&contact[email]=' + encodeURIComponent(email));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rawmango-home-bkp"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // Hide extra footer
    $('#site-footer-js').addClass('d-none');

    // Showing Submit button when we type something on email tag
    $('#contactFormEmail-2').on('keyup', function (event) {
      const email = event.target.value;
      const errorElement = $('.rm-error-js');
      const submitButton = $('.rm-fc-submit-2-js');

      // Regular expression for basic email validation
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (email === '') {
        errorElement.removeClass('d-none').text('Email can’t be blank');
        submitButton.removeClass('rm-form-control-submit');
        submitButton.addClass('d-none');
      } else if (!emailPattern.test(email)) {
        errorElement.removeClass('d-none').text('Please enter a valid email address');
        submitButton.removeClass('rm-form-control-submit');
        submitButton.addClass('d-none');
      } else {
        errorElement.addClass('d-none').text('');
        submitButton.addClass('rm-form-control-submit');
        submitButton.removeClass('d-none');
      }
    });

    // Clear Input Field
    $('.rm-form-reset-js').on('click', function () {
      $('#contactFormEmail-2').val('');
      $('.rm-error-js').addClass('d-none').text('');
      $('.rm-fc-submit-2-js').removeClass('rm-form-control-submit');
      $('.rm-fc-submit-2-js').addClass('d-none');
    });

    // Close Stay updated container
    $('.close-btn-stay-updated-js').on('click', function () {
      // $('.stay-updated-container-js').addClass('d-none');
      $('#contactFormEmail-2').val('');
      $('.rm-fc-submit-2-js').removeClass('rm-form-control-submit');
      $('.rm-fc-submit-2-js').addClass('d-none');
      $('.rm-error-js').removeClass('d-none').text('Email can’t be blank');
    });

    // Currency field change
    $('.sfa-link-js').click(function () {
      const currency = $(this).data('display-text');
      $('#hidden-currency-js').val(currency);
      $('.currency-text-desplay-js').text(currency);
    });

    // settingHeightOfFirstSection();
    function settingHeightOfFirstSection() {
      $('#fullpage');
      if ($('#section0').hasClass('active')) {
        // console.log('have active class');
        // setTimeout(function(){
        $('#fullpage').css('transform', 'translate3d(0px, 0px, 0px)');
        // },500);
      }
    }
    
    $('.accordion-item-js').on('shown.bs.collapse', function () {
      var panel = $(this).find('.show');

      $('html, body').animate(
        {
          scrollTop: panel.offset().top,
        },
        800
      );
    });
    
    $(window).on('wheel', settingHeightOfFirstSection);
  });

  document.getElementById('newsletter-home-footer-form').addEventListener('submit', function (e) {
    e.preventDefault();
    // console.log('form active');

    let formMessageDisplay = {
      signup_msg: 'Thank you for signing up!',
      subscribe_msg: 'Thank you! You are already subscribed.',
      error_msg: 'Sorry, there was an error. Please try again.',
    };

    let email = document.getElementById('contactFormEmail-2').value;
    let formMessage = document.querySelector('.form-message-display-js');
    let formMessageContainer = document.querySelector('.rm-form-success-js');
    let formLoaderCont = document.querySelector('.form-submit-container-js');
    let formContainer = document.querySelector('#newsletter-home-footer-form');
    // console.log('Email:', email);

    // Show the loader
    formLoaderCont.classList.add('form__loader--active');

    // Shopify specific AJAX call
    let xhr = new XMLHttpRequest();
    let url = '/contact';
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        console.log('inside xhr');

        // Hide the loader when the request is complete
        formLoaderCont.classList.remove('form__loader--active');

        // form will hide and message will display
        formContainer.classList.add('d-none');

        if (xhr.status === 200) {
          localStorage.setItem('isNewsLetterSubscribe', 'true');
          formMessage.innerHTML = formMessageDisplay['signup_msg'];
          formMessageContainer.classList.remove('d-none');
        } else {
          formMessage.style.color = 'red';
          formMessage.innerHTML = formMessageDisplay['error_msg'];
          formMessageContainer.classList.remove('d-none');
        }
      }
    };

    xhr.send('form_type=customer&contact[email]=' + encodeURIComponent(email));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rawmango-home-old"] && !Shopify.designMode) return;
  try {
    
  // <!-- Initialize Swiper -->
  $(document).ready(function () {
    // Showing Submit button when we type something on email tag
    $('#contactFormEmail-2').on('keyup', function (event) {
      const email = event.target.value;
      const errorElement = $('.rm-error-js');
      const submitButton = $('.rm-fc-submit-2-js');

      // Regular expression for basic email validation
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (email === '') {
        errorElement.removeClass('d-none').text('Email can’t be blank');
        submitButton.removeClass('rm-form-control-submit');
        submitButton.addClass('d-none');
      } else if (!emailPattern.test(email)) {
        errorElement.removeClass('d-none').text('Please enter a valid email address');
        submitButton.removeClass('rm-form-control-submit');
        submitButton.addClass('d-none');
      } else {
        errorElement.addClass('d-none').text('');
        submitButton.addClass('rm-form-control-submit');
        submitButton.removeClass('d-none');
      }
    });

    // Clear Input Field
    $('.rm-form-reset-js').on('click', function () {
      $('#contactFormEmail-2').val('');
      $('.rm-error-js').addClass('d-none').text('');
      $('.rm-fc-submit-2-js').removeClass('rm-form-control-submit');
      $('.rm-fc-submit-2-js').addClass('d-none');
    });

    // Close Stay updated container
    $('.close-btn-stay-updated-js').on('click', function () {
      // $('.stay-updated-container-js').addClass('d-none');
      $('#contactFormEmail-2').val('');
      $('.rm-fc-submit-2-js').removeClass('rm-form-control-submit');
      $('.rm-fc-submit-2-js').addClass('d-none');
      $('.rm-error-js').removeClass('d-none').text('Email can’t be blank');
    });

    $('.sfa-link-js').click(function () {
      const currency = $(this).data('display-text');
      $('#hidden-currency-js').val(currency);
      $('.currency-text-desplay-js').text(currency);
    });

    // Hide extra footer
    $('#site-footer-js').addClass('d-none');

    $('.accordion-item-js').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate(
        {
          scrollTop: $(this).offset().top + $(this).outerHeight(),
          behaviour,
        },
        500
      );
    });

    // Hide SliderNavbar
    // $(window).on('mousewheel', function (e) {
    //   hideSliderNavBar();
    // });

    // Get the current hash value from the URL
    let currentHash = window.location.hash;

    // The hash value you want to match (e.g., "#section1")
    let matchHash = '#newsletter-home-footer-form';

    // Check if the current hash matches the desired value
    if (currentHash === matchHash ) {
        // Temporarily clear the hash to prevent immediate scroll
        window.location.hash = '';
        console.log('Hash matches: ' + matchHash);

        // Set the hash again after a short delay
        setTimeout(() => {
            window.location.hash = '#newsletter-home-footer-form';
            // No need to reload the page; the browser will scroll to the element
            console.log('new hash added');
            // Use fullpage.js method to move to the desired section
            fullpage_api.moveTo('#newsletter-home-footer-form');
        }, 100);
    } else {
        console.log('Hash does not match');
    }


    function hideSliderNavBar() {
      console.log("inside slider navbar function");
      if ($(window).width() > 1199) {
        const fpNavBottom = $('#fp-nav').offset().top + $('#fp-nav').height();
        const sectionFooterTop = $('.fp-footer-js').offset().top;
        const section7Top = $('#section7').offset().top;
        const section7Bottom = $('#section7').offset().top + $('#section7').height();

        if (sectionFooterTop < 700) {
          $('#fp-nav').addClass('invisible');
        } else {
          $('#fp-nav').removeClass('invisible');
        }
      }
    }
  });

  // $(document).ready(function () {
  //   // Get the current hash value from the URL
  //   var currentHash = window.location.hash;

  //   // The hash value you want to match (e.g., "#section1")
  //   var matchHash = '#newsletter-home-footer-form';

  //   // Check if the current hash matches the desired value
  //   if (currentHash === matchHash) {
  //     console.log('Hash matches: ' + matchHash);
  //     // Perform your desired action here
  //     // For example, scroll to a specific section or load content
  //   } else {
  //     console.log('Hash does not match');
  //   }
  // });

  document.addEventListener('DOMContentLoaded', function () {
    // Hide extra footer on load
    document.getElementById('site-footer-js').classList.add('d-none');
    setTimeout(function () {
      document.getElementById('site-footer-js').classList.add('d-none');
    }, 100);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rawmango-home"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // Hide extra footer
    // $('#site-footer-js').addClass('d-none');

    // Showing Submit button when we type something on email tag
    $('#contactFormEmail-2').on('keyup', function (event) {
      const email = event.target.value;
      const errorElement = $('.rm-error-js');
      const submitButton = $('.rm-fc-submit-2-js');

      // Regular expression for basic email validation
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (email === '') {
        errorElement.removeClass('d-none').text('Email can’t be blank');
        submitButton.removeClass('rm-form-control-submit');
        submitButton.addClass('d-none');
      } else if (!emailPattern.test(email)) {
        errorElement.removeClass('d-none').text('Please enter a valid email address');
        submitButton.removeClass('rm-form-control-submit');
        submitButton.addClass('d-none');
      } else {
        errorElement.addClass('d-none').text('');
        submitButton.addClass('rm-form-control-submit');
        submitButton.removeClass('d-none');
      }
    });

    // Clear Input Field
    $('.rm-form-reset-js').on('click', function () {
      $('#contactFormEmail-2').val('');
      $('.rm-error-js').addClass('d-none').text('');
      $('.rm-fc-submit-2-js').removeClass('rm-form-control-submit');
      $('.rm-fc-submit-2-js').addClass('d-none');
    });

    // Close Stay updated container
    $('.close-btn-stay-updated-js').on('click', function () {
      // $('.stay-updated-container-js').addClass('d-none');
      $('#contactFormEmail-2').val('');
      $('.rm-fc-submit-2-js').removeClass('rm-form-control-submit');
      $('.rm-fc-submit-2-js').addClass('d-none');
      $('.rm-error-js').removeClass('d-none').text('Email can’t be blank');
    });

    // Currency field change
    $('.sfa-link-js').click(function () {
      const currency = $(this).data('display-text');
      $('#hidden-currency-js').val(currency);
      $('.currency-text-desplay-js').text(currency);
    });

    // settingHeightOfFirstSection();
    function settingHeightOfFirstSection() {
      $('#fullpage');
      if ($('#section0').hasClass('active')) {
        // console.log('have active class');
        // setTimeout(function(){
        $('#fullpage').css('transform', 'translate3d(0px, 0px, 0px)');
        // },500);
      }
    }

    $(window).on('wheel', settingHeightOfFirstSection);
  });

  document.getElementById('newsletter-home-footer-form').addEventListener('submit', function (e) {
    e.preventDefault();
    // console.log('form active');

    let formMessageDisplay = {
      signup_msg: 'Thank you for signing up!',
      subscribe_msg: 'Thank you! You are already subscribed.',
      error_msg: 'Sorry, there was an error. Please try again.',
    };

    let email = document.getElementById('contactFormEmail-2').value;
    let formMessage = document.querySelector('.form-message-display-js');
    let formMessageContainer = document.querySelector('.rm-form-success-js');
    let formLoaderCont = document.querySelector('.form-submit-container-js');
    let formContainer = document.querySelector('#newsletter-home-footer-form');
    // console.log('Email:', email);

    // Show the loader
    formLoaderCont.classList.add('form__loader--active');

    // Shopify specific AJAX call
    let xhr = new XMLHttpRequest();
    let url = '/contact';
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        console.log('inside xhr');

        // Hide the loader when the request is complete
        formLoaderCont.classList.remove('form__loader--active');

        // form will hide and message will display
        formContainer.classList.add('d-none');

        if (xhr.status === 200) {
          localStorage.setItem('isNewsLetterSubscribe', 'true');
          formMessage.innerHTML = formMessageDisplay['signup_msg'];
          formMessageContainer.classList.remove('d-none');
        } else {
          formMessage.style.color = 'red';
          formMessage.innerHTML = formMessageDisplay['error_msg'];
          formMessageContainer.classList.remove('d-none');
        }
      }
    };

    xhr.send('form_type=customer&contact[email]=' + encodeURIComponent(email));
  });

  function isIpad() {
    return /iPad|Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
  }

  if (isIpad()) {
    document.body.classList.add('ipad'); // Add 'ipad' class to body
    console.log("This device is an iPad.");
  } else {
    console.log("This is not an iPad.");
  }


  // Version 0
  $(document).ready(function () {
    const footerSlide = $('.rms-footer');
    const rm_swiper__home = new Swiper('.rm-swiper__home-js', {
      direction: 'vertical',
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
        thresholdDelta: 10,
      },
      slidesPerView: 'auto',
      autoHeight: false, // Enable autoHeight to adjust height on accordion open
      speed: 800,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      simulateTouch: true,
      touchRatio: 1,
      touchAngle: 45,
      threshold: 10,
      longSwipes: false,
      touchMoveStopPropagation: true,
    });

    rm_swiper__home.on('slideChange', function () {
      const activeIndex = rm_swiper__home.activeIndex;
      const footerIndex = rm_swiper__home.slides.length - 1;

      if (activeIndex === footerIndex) {
        rm_swiper__home.pagination.el.style.display = 'none';
        rm_swiper__home.params.thresholdDelta = 50;
        document.body.style.overflow = 'auto';
      } else {
        rm_swiper__home.pagination.el.style.display = '';
        rm_swiper__home.params.thresholdDelta = 10;
        document.body.style.overflow = 'hidden';
      }
    });

    // Handle accordion show event
    $('.accordion-item-js').on('shown.bs.collapse', function () {
      rm_swiper__home.update();
      const footerIndex = rm_swiper__home.slides.length - 1; // Get the footer index
      rm_swiper__home.slideTo(footerIndex); // Programmatically slide to footer
    });

    // Update Swiper when accordion items are collapsed
    $('.accordion-item-js').on('hidden.bs.collapse', function () {
      rm_swiper__home.update(); // Update Swiper to recalculate dimensions
    });
  });

  // Version 1
  // $(document).ready(function () {
  //   const footerSlide = $('.rms-footer');

  //   const rm_swiper__home = new Swiper('.rm-swiper__home-js', {
  //     direction: 'vertical',
  //     mousewheel: {
  //       forceToAxis: true,
  //       sensitivity: 1,
  //       releaseOnEdges: true,
  //       thresholdDelta: 10,
  //     },
  //     slidesPerView: 'auto',
  //     autoHeight: false,
  //     speed: 800,
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true,
  //     },
  //     simulateTouch: true,
  //     touchRatio: 1,
  //     touchAngle: 45,
  //     threshold: 10,
  //     longSwipes: false,
  //     // longSwipesMs: 300,
  //     // longSwipesRatio: 0.5,
  //     touchMoveStopPropagation: true,
  //   });

  //   rm_swiper__home.on('slideChange', function () {
  //     const activeIndex = rm_swiper__home.activeIndex;
  //     const footerIndex = rm_swiper__home.slides.length - 1;

  //     if (activeIndex === footerIndex) {
  //       rm_swiper__home.pagination.el.style.display = 'none';

  //       // $('html, body').animate(
  //       //   {
  //       //     scrollTop: footerSlide.offset().top,
  //       //   },
  //       //   800
  //       // );
  //       //rm_swiper__home.params.touchRatio = 0.5; // Increase swipe sensitivity for the last slide
  //       rm_swiper__home.params.tthresholdDelta = 50;
  //       document.body.style.overflow = 'auto';
  //     } else {
  //       rm_swiper__home.pagination.el.style.display = '';
  //       rm_swiper__home.params.tthresholdDelta = 10;
  //       document.body.style.overflow = 'hidden';
  //     }
  //   });

  //   $('.accordion-item-js').on('shown.bs.collapse', function (e) {
  //     rm_swiper__home.update();
  //     //console.log("Update");
  //     // $('html, body').animate({ scrollTop: $(document).height() }, 1000);
  //   });

  //   $('.accordion-item-js').on('hidden.bs.collapse', function () {
  //     rm_swiper__home.update();
  //   });
  //   // Scroll down when accordion is opened
  //   // document.querySelectorAll('.accordion-button').forEach((button) => {
  //   //   button.addEventListener('click', function () {
  //   //     // $('html, body').animate({ scrollTop: $(document).height() }, 3000);
  //   //   });
  //   // });
  // });

  // Version 2
  // $(document).ready(function () {
  //     const footerSlide = $('.rms-footer');

  //     const rm_swiper__home = new Swiper('.rm-swiper__home-js', {
  //       direction: 'vertical',
  //       mousewheel: {
  //         forceToAxis: true,
  //         sensitivity: 1,
  //         releaseOnEdges: true,
  //         thresholdDelta: 10,
  //       },
  //       slidesPerView: 'auto',
  //       autoHeight: false,
  //       speed: 800,
  //       pagination: {
  //         el: '.swiper-pagination',
  //         clickable: true,
  //       },
  //     });

  //     // Hide pagination when footer slide is active
  //     rm_swiper__home.on('slideChange', function () {
  //       const activeIndex = rm_swiper__home.activeIndex;
  //       const footerIndex = rm_swiper__home.slides.length - 1;

  //       if (activeIndex === footerIndex) {
  //         rm_swiper__home.pagination.el.style.display = 'none';
  //       } else {
  //         rm_swiper__home.pagination.el.style.display = '';
  //       }
  //     });

  //     // Handle accordion opening inside footer
  //     $('.accordion-item-js').on('shown.bs.collapse', function () {
  //       rm_swiper__home.update();

  //       // Scroll to the accordion item and make sure it's fully visible
  //       const accordionItem = this;
  //       accordionItem.scrollIntoView({
  //         behavior: 'smooth', // Smooth scroll
  //         block: 'start' // Aligns the top of the element to the top of the viewport
  //       });
  //     });

  //     // Update Swiper when accordion closes
  //     $('.accordion-item-js').on('hidden.bs.collapse', function () {
  //       rm_swiper__home.update();
  //     });
  // });

  // Version 3
  // $(document).ready(function () {
  //     const footerSlide = $('.rms-footer');

  //     const rm_swiper__home = new Swiper('.rm-swiper__home-js', {
  //       direction: 'vertical',
  //       mousewheel: {
  //         forceToAxis: true,
  //         sensitivity: 1,
  //         releaseOnEdges: true,
  //         thresholdDelta: 10,
  //       },
  //       slidesPerView: 'auto',
  //       autoHeight: false,
  //       speed: 800,
  //       pagination: {
  //         el: '.swiper-pagination',
  //         clickable: true,
  //       },
  //     });

  //     // Hide pagination when footer slide is active
  //     rm_swiper__home.on('slideChange', function () {
  //       const activeIndex = rm_swiper__home.activeIndex;
  //       const footerIndex = rm_swiper__home.slides.length - 1;

  //       if (activeIndex === footerIndex) {
  //         rm_swiper__home.pagination.el.style.display = 'none';
  //       } else {
  //         rm_swiper__home.pagination.el.style.display = '';
  //       }
  //     });

  //     // Function to scroll to the bottom of the active slide
  //     function scrollToBottom(swiper) {
  //       console.log("Scroll to Bottom");
  //       const swiperContainer = document.querySelector('.rm-swiper__home-js');
  //       const accordionContent = document.querySelector('.accordion-collapse');
  //       //const slideHeight = currentSlide.offsetHeight;
  //       const accordionHeight = accordionContent.scrollHeight;

  //       const currentSlide = swiper.slides[swiper.activeIndex];
  //       const slideHeight = currentSlide.offsetHeight; // Get the height of the current slide
  //       console.log(currentSlide.offsetHeight);
  //       //swiper.wrapperEl.scrollTo({ top: slideHeight, behavior: 'smooth' });
  //       swiperContainer.style.height = `${slideHeight + accordionHeight}px`;
  //       window.scrollTo({ top: document.body.scrollHeight});
  //     }

  //     // Handle accordion opening inside footer
  //     $('.accordion-item-js').on('shown.bs.collapse', function () {
  //       rm_swiper__home.update();

  //       setTimeout(function () {
  //         scrollToBottom(rm_swiper__home);
  //       },1000)
  //     });

  //     // Update Swiper when accordion closes
  //     $('.accordion-item-js').on('hidden.bs.collapse', function () {
  //       rm_swiper__home.update();
  //     });
  // });

  } catch(e) { console.error(e); }
})();
})();
